<template>
    <b-link
        class="text-center"
        :href="
            `${origin}/app/objectives/${objectiveId}/keyResults/${keyResultId}/checkin`
        "
    >
        <i class="fa fa-calendar-check-o fa-lg" />
        <p class="m-0">
            <small>Check-in</small>
        </p>
    </b-link>
</template>

<script>
import { getOrigin } from '@/lib/url'

export default {
    name: 'ToCheckIn',
    props: ['objectiveId', 'keyResultId'],
    data() {
        return {
            origin: getOrigin(),
        }
    },
}
</script>
